import { Label } from "@radix-ui/react-context-menu";

import { label } from "../../css/menu";
import { styled } from "../../theme/stitches";

export const ContextMenuLabel = styled(Label, label);
